/* eslint-disable
no-return-await, no-console, no-param-reassign,
no-trailing-spaces, arrow-body-style,
*/
import axios from 'axios';
import moment from 'moment';

import helper from '@/_libs/helper';
import _customer from './_customer';
import order from '../_order';

const {
  ORDER_STATUS,
  SHIPMENT_STATUS,
  BACK_ORDER_STATUS,
  CUSTOMERS,
  SELLERS,
} = _customer;

const DATE_TODAY = moment().format('YYYY-MM-DD');

const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const CURRENT_TIME = new Date().getTime();


const MOCK = {
  sellRecord: {
    sell: [
      {
        entryNo: '24/567',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[0],
        user: SELLERS[0],
        weight: 12,

        updated: true,
      },
      {
        entryNo: '24/569',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.UNIX,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[0],
        user: SELLERS[0],
        weight: 10,

        updated: true,
      },
      {
        entryNo: '24/568',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 55555,
        status: ORDER_STATUS.UNIX,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[1],
        user: SELLERS[1],
        weight: 6,
      },
      {
        entryNo: '24/609',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 12345,
        status: ORDER_STATUS.APPROVED,
        shipmentStatus: SHIPMENT_STATUS.DELIVERED,
        customer: CUSTOMERS[1],
        user: SELLERS[2],
        weight: 2,

        updated: true,
      },
      {
        entryNo: '24/519',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 76739,
        status: ORDER_STATUS.REJECTED,
        shipmentStatus: SHIPMENT_STATUS.REJECTED,
        customer: CUSTOMERS[2],
        user: SELLERS[3],
        weight: 4,
      },
    ],
    adminApproval: [
      {
        entryNo: '20/567',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[0],
        user: SELLERS[0],
        weight: 12,

        updated: true,
      },
      {
        entryNo: '20/569',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 69990,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[0],
        user: SELLERS[0],
        weight: 10,

        updated: true,
      },
      {
        entryNo: '20/568',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 55555,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[1],
        user: SELLERS[1],
        weight: 6,
      },
      {
        entryNo: '20/609',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 12345,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[1],
        user: SELLERS[2],
        weight: 2,

        updated: true,
      },
      {
        entryNo: '20/519',
        date: DATE_TODAY,
        time: CURRENT_TIME,
        total: 76739,
        status: ORDER_STATUS.PENDING,
        shipmentStatus: SHIPMENT_STATUS.PENDING,
        customer: CUSTOMERS[2],
        user: SELLERS[3],
        weight: 4,
      },
    ],
    unpaid: [
      {
        id: 0,
        dueDate: DATE_LASTWEEK,
        entryNo: 'AB63111205',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,

        customer: CUSTOMERS[2],
        user: SELLERS[3],

        updated: true,
      },
      {
        id: 1,
        dueDate: DATE_3_DAYS_AGO,
        entryNo: 'AB63111206',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_LASTWEEK,

        customer: CUSTOMERS[1],
        user: SELLERS[2],
      },
      {
        id: 2,
        dueDate: DATE_3_DAYS_AGO,
        entryNo: 'AB63111207',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 12453.46,
        sellDate: DATE_LASTWEEK,

        customer: CUSTOMERS[1],
        user: SELLERS[3],
      },
      {
        id: 3,
        dueDate: DATE_YESTERDAY,
        entryNo: 'AB63111208',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 69000.46,
        sellDate: DATE_3_DAYS_AGO,

        customer: CUSTOMERS[1],
        user: SELLERS[0],

        updated: true,
      },
      {
        id: 4,
        dueDate: DATE_YESTERDAY,
        entryNo: 'AB63111209',
        customerName: 'บริษัท เอส 11 กรุ๊ป จำกัด (มหาชน)',
        total: 9198.46,
        sellDate: DATE_LASTWEEK,

        customer: CUSTOMERS[2],
        user: SELLERS[0],

        updated: true,
      },
    ],
    backOrder: [
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111205',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.READY,

        customer: CUSTOMERS[0],
        user: SELLERS[1],

        updated: true,
      },
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111209',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.READY,

        customer: CUSTOMERS[1],
        user: SELLERS[1],

        updated: true,
      },
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111212',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.WAITING,

        customer: CUSTOMERS[1],
        user: SELLERS[2],
      },
      {
        date: DATE_TODAY,
        entryNo: 'AB63111213',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.WAITING,

        customer: CUSTOMERS[1],
        user: SELLERS[0],
      },
      {
        date: DATE_TODAY,
        entryNo: 'AB63111220',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.WAITING,

        customer: CUSTOMERS[2],
        user: SELLERS[2],
      },
      {
        date: DATE_YESTERDAY,
        entryNo: 'AB63111201',
        productId: 'D6XN5CM',
        productName: 'ไม้อัด ตรากระต่าย',
        quantity: 12,
        total: 69000.46,
        status: BACK_ORDER_STATUS.CANCELLED,

        customer: CUSTOMERS[1],
        user: SELLERS[1],

        updated: true,
      },
    ],
  },
};

const sellRecord = {
  async sell(page = 1, from, to, filterSearch, filterStatus = undefined, filterArea = undefined) {
    return await helper.call('sellRecord.sell', {
      success: true,
      data: MOCK.sellRecord.sell,
    }, async () => {
      const res = await order.list(filterStatus, page, from, to, filterSearch, filterArea);

      // filter out back_order & quotation
      res.data.data = res.data.data.filter((elm) => {
        return ['back_order', 'quotation'].includes(elm.apiStatus) === false;
      });
      return res;
    });
  },
  async csApprovalList(page = 1, filterDate = { from: undefined, to: undefined }) {
    return await helper.call('sellRecord.csApproval', {
      success: true,
      data: [],
    }, async () => {
      const res = await order.list('pending_cs', page, filterDate.from, filterDate.to);
      return res;
    });
  },
  async adminApprovalList(page = 1, from, to, filterSearch, filterArea) {
    return await helper.call('sellRecord.adminApproval', {
      success: true,
      data: MOCK.sellRecord.adminApproval,
    }, async () => {
      const res = await order.list('pending_admin', page, from, to, filterSearch, filterArea);
      return res;
    });
  },
  async unpaid(id) {
    console.log(id);
    return await helper.call('sellRecord.unpaid', {
      success: true,
      data: MOCK.sellRecord.unpaid,
    }, async () => await axios(helper.path('sell-record/unpaid')));
    // TODO: connect to API
  },
  async backOrder(page = 1, from, to, filterSearch) {
    return await helper.call('sellRecord.backOrder', {
      success: true,
      data: MOCK.sellRecord.backOrder,
    }, async () => {
      const res = await order.list('back_order', page, from, to, filterSearch);

      const BACK_ORDERS = [];
      const { data } = res.data;
      for (let i = 0; i < data.length; i += 1) {
        const DAT = data[i];
        for (let j = 0; j < DAT.products.length; j += 1) {
          const PROD = DAT.products[j];

          BACK_ORDERS.push({
            ...DAT,

            date: DAT.updated_at,
            entryNo: DAT.unix_id,
            combinedId: `${DAT.unix_id}/${DAT.id}`,

            total: Number(PROD.price),
            productId: PROD.product.id,
            productName: PROD.product.name,
            productPrice: Number(PROD.price / PROD.amount),
            amount: PROD.amount,

            products: undefined, // unused in back orders
            product: PROD,
          });
          // console.log(BACK_ORDERS);
        }
      }

      res.data.data = BACK_ORDERS;
      return res;
    });
  },
};

export default sellRecord;
